import Disbursement from "@components/dashboard/disbursement/Disbursement";
import { isAmpliDisbursementPolicy } from "@components/dashboard/financialProjection/cashFlowPlanning";
import { useProjectContext } from "@contexts/projects";

import Advancements from "./Advancements";

/**
 * Uma rota só (`adiantamentos`, permissão `Adiantamentos`) com duas páginas: o
 * módulo novo quando a organização escolheu `ampli_disbursement`, e a tela atual
 * de ajustes de mês do Sienge em todos os outros casos (spec 8.1).
 */
const DisbursementRoute = () => {
  const { activeProject } = useProjectContext();
  return isAmpliDisbursementPolicy(activeProject?.cashFlowPlanning)
    ? <Disbursement />
    : <Advancements />;
};

export default DisbursementRoute;
